var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.data
    ? _c("ul", [
        _c(
          "li",
          { staticClass: "data-block-number" },
          [
            _c("p", { staticClass: "data-label" }, [
              _vm._v(_vm._s(_vm.$l10n.__("Sur l'exercice fiscal")))
            ]),
            _vm._v(" "),
            _c("h3", { staticClass: "data-value" }, [
              _vm._v(
                "\n            " +
                  _vm._s(
                    _vm._f("numberformatWithOptions")(
                      _vm.data.year,
                      { currencysymbol: _vm.currencySymbol },
                      true
                    )
                  ) +
                  "\n        "
              )
            ]),
            _vm._v(" "),
            _c("number-diff", {
              attrs: {
                tooltipText: _vm.$t.__(
                  "dashboard.cards.TemplateTurnoverCard.compare_to_previous_year"
                ),
                amount: _vm.data.year,
                comparison: _vm.data.lastYear,
                currencySymbol: _vm.currencySymbol
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "li",
          { staticClass: "data-block-number" },
          [
            _c("p", { staticClass: "data-label" }, [
              _vm._v(_vm._s(_vm.$l10n.__("Ce mois")))
            ]),
            _vm._v(" "),
            _c("h3", { staticClass: "data-value" }, [
              _vm._v(
                "\n            " +
                  _vm._s(
                    _vm._f("numberformatWithOptions")(
                      _vm.data.month,
                      { currencysymbol: _vm.currencySymbol },
                      true
                    )
                  ) +
                  "\n        "
              )
            ]),
            _vm._v(" "),
            _c("number-diff", {
              attrs: {
                tooltipText: _vm.$t.__(
                  "dashboard.cards.TemplateTurnoverCard.compare_to_previous_month"
                ),
                amount: _vm.data.month,
                comparison: _vm.data.lastMonth,
                currencySymbol: _vm.currencySymbol
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("li", { staticClass: "data-block-number" }, [
          _c("p", { staticClass: "data-label" }, [
            _vm._v(_vm._s(_vm.$l10n.__("Aujourd'hui")))
          ]),
          _vm._v(" "),
          _c("h3", { staticClass: "data-value" }, [
            _vm._v(
              "\n            " +
                _vm._s(
                  _vm._f("numberformatWithOptions")(
                    _vm.data.day,
                    { currencysymbol: _vm.currencySymbol },
                    true
                  )
                ) +
                "\n        "
            )
          ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }